// @flow

export function translateErrorMessageEN(errorCode: string): ?string {
  switch (errorCode) {
    case 'CI-000':
    case 'BP-DR-112':
      return 'Please use another card, or select another payment method.';
    case 'IT-500':
      return 'Bad connection. Check your Internet connection and try again.';
    case 'PR-001':
      return 'Your payment has not been approved. Please review your details or choose another payment method.';
    case 'BP-R-32':
      return 'This purchase exceeded the limit allowed on EBANX.';
    case 'BP-DR-6':
    case 'BP-DR-7':
      return 'This payment method is not available for the amount of your purchase. Please select another payment method.';
    case 'BP-DR-13':
      return 'Name is required.';
    case 'BP-DR-15':
      return 'Email is required.';
    case 'BP-DR-17':
      return 'Invalid email.';
    case 'BP-DR-18':
      return 'Oh, no! Apparently there was a problem with your account. Please contact our support.';
    case 'BP-DR-21':
      return 'To complete this purchase, you must be at least 16 years old. Ask someone older than 16 to help you complete the payment :)';
    case 'BP-DR-22':
      return 'ID is required.';
    case 'BP-DR-23':
      return 'Invalid ID.';
    case 'BP-DR-24':
      return 'Postal code is required.';
    case 'BP-DR-25':
      return 'Street is required.';
    case 'BP-DR-26':
      return 'Address number is required.';
    case 'BP-DR-27':
      return 'City is required.';
    case 'BP-DR-28':
      return 'Province is required.';
    case 'BP-DR-29':
      return 'Invalid province.';
    case 'BP-DR-31':
      return 'Phone is required.';
    case 'BP-DR-32':
      return 'Invalid phone number.';
    case 'BP-DR-35':
      return 'Oops! there was an error with your payment :( Please try again or choose another payment method to complete your purchase.';
    case 'BP-DR-38':
      return 'There was a problem with your payment. Please choose another payment method.';
    case 'BP-DR-39':
      return 'Oops! We\'ve identified a problem with your ID, please try with another one or contact us.';
    case 'BP-DR-40':
      return 'You have reached your monthly payment limit.';
    case 'BP-DR-51':
      return 'Oops! This field is missing. Fill it with your card number.';
    case 'BP-DR-55':
      return 'Invalid security code (CVV).';
    case 'BP-DR-59':
      return 'Oops! This payment method is not available. But don\'t worry, you can still complete your purchase with another payment method.';
    case 'BP-DR-67':
      return 'Invalid expiration date.';
    case 'BP-DR-75':
      return 'Invalid card number.';
    case 'BP-DR-76':
      return 'Bank is required.';
    case 'BP-DR-79':
      return 'The number of installments is higher than allowed.';
    case 'BP-DR-83':
      return 'We do not process cards issued outside the country. Please use another card, or select another payment method.';
    case 'BP-DR-84':
      return 'Duplicate payment for the same customer with the same amount.';
    case 'BP-DR-90':
      return 'Oh, no! Apparently there was a problem with your account. Please contact our support.';
    case 'BP-DR-91':
      return 'Oops! There was an error with your payment :( Please try again or complete the purchase using another payment method.';
    case 'BP-DR-95':
      return 'Oops! Please confirm that you have completed this field with your name and not with other card information.';
    case 'BP-DR-97':
      return 'Your card does not accept installment payments.';
    case 'BP-DR-98':
      return 'The customer associated to this e-mail is from another country. Please use another e-mail address.';
    case 'BP-DR-100':
      return 'Your card does not accept installment payments.';
    case 'BP-DR-101':
      return 'Your card is not accepted for online purchases.';
    case 'BP-DR-102':
      return 'There was a problem with your payment. Please try again.';
    case 'BP-DR-103':
      return 'Oops! Your transaction could not be completed. Contact EBANX, send an email to support@ebanx.com to understand what happened.';
    case 'BP-DR-111':
      return 'We could not validate your ID, please try again later.';
    case 'BP-DR-172':
      return 'Account number is required.';
    case 'BP-DR-174':
      return 'Upi Id is required.';
    case 'AR-DB-044':
    case 'AR-DB-075':
      return 'Wrong CUIT. You must enter the CUIT of the account holder.';
    case 'BP-DOC-04':
      return 'We have identified that your registration is reported in the Unreliable Taxpayers Database of the Tax Collection and Customs Control Agency (ARCA).\
 Due to this inclusion, we are currently unable to offer our services for accepting payments with transfers or cards (debit, credit, purchase or prepaid).\
 We recommend that you contact ARCA to regularize or clarify your situation. As soon as your regularization is confirmed and the status is updated in the ARCA database,\
 we will be able to reactivate the services.';
    default:
      return undefined;
  }
}
